export default __webpack_public_path__ + "media/images/images_v2/home-over-e697bbf3b4ccdff71dfa7625c437dab1.png";